<template>
  <div class="terms-amazsd-69 terms-ecs-2022 terms-ecs-2023">
   <div class="eventInformation">
    <v-container>
     <v-layout>
      <v-flex md8 xs12 class="terms" v-if="!viewOnly && !event">
       <h3>One moment please.</h3>
       <p>If this message persists, we may have encountered a problem. Please email <a href="mailto:amaze@rti.org">amaze@rti.org</a> and let us know.</p>
      </v-flex>
      <v-flex md8 xs12 class="terms" v-else>

       <h3>Waiver and Release Form</h3>

       <div>
        <p>I, the undersigned ("Participant"), in consideration for my voluntary participation in the <strong v-if="event">{{event}}</strong><strong v-else>2023 Early College Summit</strong> on <strong v-if="event">{{event_date}}</strong><strong v-else>June 6-7, 2023</strong>, hosted by Research Triangle Institute, under the trade name RTI International (RTI) at RTI Headquarters, Camille Dreyfus Auditorium, Haynes Building West Institute Drive, Research Triangle Park, NC 27709 (“Event”), do hereby willfully acknowledge that my electronic acceptance attests to my understanding and agreement that:
        </p>

        <h4>ADMITTANCE</h4>
        <p>In our sole discretion, without refund, RTI reserves the right to refuse admittance to or expel from the Event anyone that we determine is behaving in a manner that could be disruptive to the Event or any other.</p>

        <h4>PAYMENT TERMS</h4>
        <p>RTI will send invoices to Participant’s named point of contact (Registration 1) at the email provided. Payment terms are NET 30. Participant will not be obligated to pay RTI costs that exceed the amount authorized by the Registration Form.</p>

        <h4>CANCELLATION, REFUND, AND SUBSTITUTION POLICY</h4>
        <p>Event registration may be cancelled up to thirty (30) calendar days before the Event date by providing written notice of cancellation to RTI using the instructions on the Event website. Provided the registered Participant cancels by written notice within the allowable timeframe, RTI will either 1) cancel the invoice, or 2) refund the registration fee to the entity who made payment on behalf of the Participant.</p>
        <p>Participant(s) who provide written notice of cancellation thirty (30) days or less before the Event date are not eligible for a refund. If the Event registration fee has not been received by RTI, the entity responsible for making payment on behalf of the Participant(s) shall be invoiced, and payment shall be due.</p>
        <p>Substitutions of Participant(s) may be made up to seven (7) calendar days before the Event. Substitutions must be made within the allowable timeframe by providing written notice using the instructions on the Event website.</p>
        <p>The refund and cancellation policy will not be waived.</p>
        <p>In the event RTI must cancel the Event due to unforeseen circumstances, RTI will refund the cost of registrations paid. However, RTI does not assume responsibility for any additional costs, charges, or expenses; to include, charges made for travel and lodging.</p>

        <h4>VISITOR BADGES</h4>
        <p>Participants will be issued a visitor badge upon entering the Haynes Building on RTI’s Research Triangle Park, NC, campus. Participants will display badges while attending the Event. Visitor badges are valid for named Participant only and, cannot be transferred. Participants may be asked for photographic ID during the Event. If Participant is unable to provide identification, which matches their badge, Participant may be asked to leave the Event. Participant badges will expire at the end of the Event. Participant will restrict myself to the areas designated for the Event and in accordance with the Event schedule/agenda.</p>

        <h4>PHOTOGRAPHY, AUDIO, AND VIDEO RECORDING</h4>
        <p>The Event is held on RTI’s Research Triangle Park, NC closed campus, and therefore RTI prohibits Participants, exhibitors, sponsors, news organizations and other companies from photographing or video or audio-taping some Event activities. RTI reserves the right to use images taken at the Event with Participants’ photographs and/or likeness in future marketing materials. RTI may edit, alter, copy, exhibit, distribute, and publish in print, video, audio recorded productions, and on the internet material from the Event for purposes of publicizing RTI programs or other lawful purpose without payment or any other consideration. The photography, audio and video recording will become the property of RTI, stored in a place chosen by RTI and will not be returned to Participant(s). In addition, Participant(s) waive the right to inspect or approve the finished product, including written or electronic copy, wherein my likeness appears. Participant(s) waive any right to royalties or other compensation arising or related to the use of the photography, audio, and video recording</p>

        <h4>ALCOHOL, TOBACCO, AND DRUG POLICY</h4>
        <p>Alcohol and tobacco will not be permitted on RTI premises during the Event. RTI prohibits smoking (including vaping) on RTI’s campus. Participant(s) found possessing or using illicit drugs, as defined by United States federal law, will be required to leave the Event premises immediately and may be held criminally liable.</p>

        <h4>VALUABLES</h4>
        <p>Participant(s) are solely responsible for any valuables they decide to bring to the Event. RTI is not responsible for belongings left on Event premises.</p>

        <h4>LIABILITY</h4>
        <p>I, Participant, hereby release, waive liability, discharge, hold harmless, indemnify, and covenant not to sue the RTI for any and all liability incurred in the conduct of, and my participation in, this Event.</p>
        <p>Participant will report any and all injuries to RTI staff immediately. Should any medical emergency arise, Participant will first call 911.</p>
        <p>RTI executives are the only staff members empowered to grant exceptions to any Event policies or other general RTI practices. I, Participant, will not liable hold RTI liable for any erroneous statements made by other staff members regarding exceptions to fees or policies. Purchase orders supplied by the payee for the registered Participant shall be for accounting identification purposes only, and any terms or conditions therein or in any acknowledgement, confirmation, or other communication by the Participant in addition to or in conflict with the Event terms and conditions are rejected.</p>

       </div>
       <div v-if="!viewOnly">
       <p>NAME: {{name}}<br />

        DATE: {{date}}</p>
       <div v-if="!accepted">
       <v-form ref="termsForm">
       <v-checkbox
        required
        v-model="terms"
        :rules="rules.terms"
       >
        <template slot='label'>By checking this box, you agree to the terms and conditions.<span class='star'>*</span></template>
       </v-checkbox>
       <v-btn
        class='ml-0'
        color="primary"
        @click="submitTerms()"
        v-if="!submitted"
       >Submit</v-btn>
       <v-progress-circular v-else indeterminate />

       </v-form>
       </div>
       <div v-else>
        <h4>Thank you!</h4>
        <p v-if="accepted_date">You accepted the terms and conditions <strong>{{accepted_date |localTime}} ago</strong>.</p>
        <p>Please be on the lookout for more messages from us as we lead up to the event.<br />We are looking forward to having you join us!</p>
       </div>
       </div>
      </v-flex>
     </v-layout>
    </v-container>
   </div>
  </div>
 </template>

 <style scoped lang="scss">
  .terms-ecs-2023 {
    word-break: break-word;
    div {
      word-break: break-word;
    }
}

 </style>

<script>
export default {
  data() {
    return {
      user: null,
      name: "",
      date: new Date().toLocaleDateString(),
      event: "",
      event_date: "",
      event_waiver: "default",
      terms: null,
      accepted: false,
      accepted_date: null,
      submitted: false,
      rules: {
        terms: [
          v => !!v || "You must accept the terms and conditions to continue."
        ]
      }
    };
  },
  methods: {
    submitTerms() {
      if (this.$refs.termsForm.validate()) {
        this.submitted = true;
        this.$http
          .put("registration/terms/" + this.user.uuid, { terms: 1 })
          .then(response => {
            this.accepted = true;
            this.accepted_date = response.data.data[0].updated_at;
            this.$store.commit("updateMessage", {
              message: "The terms have been accepted.",
              snackbar: true
            });
          });
      }
    }
  },
  computed: {
    waiver: function() {
      // For now we assume that there are two flavors of waivers:
      // Default (on location) and virtual.
      switch (this.event_waiver.trim().toLowerCase()) {
        case 'virtual':
          return 'virtual';
        default:
          return 'default';
      }
    },
    defaultWaiver: function() {
      return this.waiver === 'default';
    },
    virtualWaiver: function() {
      return this.waiver === 'virtual';
    },
    viewOnly: function() {
      // If no uuid is provided, then this is a view only mode.
      return !this.$route.params.uuid;
    }
  },
  mounted() {
    if (!this.$route.params.uuid) {
      return;
    }

    this.$http.get("registration/terms/" + this.$route.params.uuid).then(
      response => {
        this.user = response.data.data[0];
        this.name = this.user.name;
        this.event = this.user.registration.registration_event.name;
        this.event_date = this.user.registration.registration_event.dates;
        this.event_waiver = this.user.registration.registration_event.content.waiver || "default";
        if (this.user.terms) {
          this.terms = this.user.terms;
          this.accepted = true;
          this.accepted_date = this.user.updated_at;
        }
        this.$store.commit("updateMessage", {
          message: "Please review the terms and conditions.",
          snackbar: true
        });
      },
      response => {
        this.$store.commit("updateMessage", {
          message:
        "Error: Your information was not found. Please contact support.",
          snackbar: true
        });
        this.$router.push({ path: "/event/missing-token" });
      }
    );
  }
};
</script>
